<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="Blurb">Babette Bechtold was raised in Portland, the beautiful state of Oregon, and moved to Washington State to attend college where she married and raised her three daughters. Babette considers her faith and family to be most important to her. If she isn’t spending time with her friends and family, you can almost always find her reading, journaling, gardening, or sewing. <span class="CharOverride-1">The Shark with The Kind Heart</span> is Babette’s first children’s book.</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="Graphic"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9798886939668_txt2.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer004">
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
<p class="Heading ParaOverride-1">Copyright © Babette Bechtold 2024</p>
<p class="Normal-CP ParaOverride-1">All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other non-commercial uses permitted by copyright law. For permission requests, write to the publisher.</p>
<p class="Normal-CP ParaOverride-1">Any person who commits any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p class="Normal-CP"><span class="CharOverride-2">Ordering Information</span></p>
<p class="Normal-CP">Quantity sales: Special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the publisher at the address below.</p>
<p class="Normal-CP ParaOverride-2"><span class="CharOverride-2">Publisher’s Cataloging-in-Publication data</span></p>
<p class="Normal-CP">Bechtold, Babette</p>
<p class="Normal-CP ParaOverride-1">The Shark With A Kind Heart</p>
<p class="Normal-CP">ISBN 9798886939668 (Paperback)</p>
<p class="Normal-CP">ISBN 9798886939675 (Hardback)</p>
<p class="Normal-CP ParaOverride-1">ISBN 9798886939682 (ePub e-book)</p>
<p class="Normal-CP ParaOverride-1">Library of Congress Control Number: 2023924204</p>
<p class="Normal-CP ParaOverride-1">www.austinmacauley.com/us</p>
<p class="Normal-CP">First Published 2024</p>
<p class="Normal-CP">Austin Macauley Publishers LLC</p>
<p class="Normal-CP">40 Wall Street, 33rd Floor, Suite 3302 </p>
<p class="Normal-CP">New York, NY 10005</p>
<p class="Normal-CP ParaOverride-1">USA</p>
<p class="Normal-CP">mail-usa@austinmacauley.com</p>
<p class="Normal-CP">+1 (646) 5125767</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="Dedi">To my three daughters, Joy, Kristen, and Chloe, who inspire me to be kind every day.</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer008">
<p class="Graphic"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9798886939668_txt6.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer009">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer010">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer011">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub2.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer012">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer013">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub3.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer014">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer015">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub4.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer016">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer017">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub5.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer018">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer019">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub6.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer020">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer021">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub7.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer022">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer023">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub8.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer024">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer025">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub9.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer026">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer027">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub10.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer028">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer029">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub11.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer030">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer031">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub12.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer032">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer033">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub13.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer034">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer035">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub14.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer036">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer037">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub15.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer038">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer039">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub16.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer040">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer041">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub17.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer042">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer043">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub18.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer044">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer045">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub19.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer046">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer047">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub20.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer048">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer049">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub21.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer050">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer051">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub22.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer052">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer053">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub23.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer054">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer055">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub24.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer056">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer057">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub25.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer058">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer059">
<img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9798886939682_Epub26.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer060">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9798886939682_Epub.vue?a17d03c6